import { render, staticRenderFns } from "./TrainyudingRight.vue?vue&type=template&id=4195b591&scoped=true"
import script from "./TrainyudingRight.vue?vue&type=script&lang=js"
export * from "./TrainyudingRight.vue?vue&type=script&lang=js"
import style0 from "./TrainyudingRight.vue?vue&type=style&index=0&id=4195b591&prod&lang=css"
import style1 from "./TrainyudingRight.vue?vue&type=style&index=1&id=4195b591&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4195b591",
  null
  
)

export default component.exports